import {
  keepPreviousData,
  useQuery,
  type UseQueryResult,
} from '@tanstack/react-query';
import service from '../service';
import {
  statsRangeParams,
  type EngagementStats,
  type StatsRange,
} from '@Types/messagingStats';

export function useEngagementStats(
  range: StatsRange,
): UseQueryResult<EngagementStats, Error> {
  return useQuery<EngagementStats, Error>({
    queryKey: ['engagement-stats', 'stats', statsRangeParams(range)],
    queryFn: () => service.getEngagementStats(range),
    placeholderData: keepPreviousData,
  });
}
